import React, { useCallback, useMemo, useState } from 'react';

export const useAudioProgressBar = () => {
  const [currrentProgress, setCurrrentProgress] = React.useState(0);
  const [playing, setPlaying] = useState(false);
  const [buffered, setBuffered] = React.useState(0);
  const [duration, setDuration] = useState(0);
  const handleBufferProgress = useCallback(
    (e: React.SyntheticEvent<HTMLAudioElement, Event>) => {
      const audio = e.currentTarget;
      const dur = audio.duration;
      if (dur > 0) {
        for (let i = 0; i < audio.buffered.length; i++) {
          if (audio.buffered.start(audio.buffered.length - 1 - i) < audio.currentTime) {
            const bufferedLength = audio.buffered.end(audio.buffered.length - 1 - i);
            setBuffered(bufferedLength);
            break;
          }
        }
      }
    },
    [setBuffered],
  );

  const onTimeUpdate = useCallback(
    (e: React.SyntheticEvent<HTMLAudioElement>) => {
      setCurrrentProgress(e.currentTarget.currentTime);
      handleBufferProgress(e);
    },
    [setCurrrentProgress, handleBufferProgress],
  );

  const stopBufferProgress = useCallback(() => {
    setCurrrentProgress(0);
    setBuffered(0);
  }, [setCurrrentProgress, setBuffered]);

  return {
    buffered: useMemo(() => buffered, [buffered]),
    currrentProgress: useMemo(() => currrentProgress, [currrentProgress]),
    duration: useMemo(() => duration, [duration]),
    playing: useMemo(() => playing, [playing]),
    handleBufferProgress,
    onTimeUpdate,
    setCurrrentProgress,
    setDuration,
    setPlaying,
    stopBufferProgress,
  };
};
